module.exports = __webpack_public_path__ + "img/image.b04910b5.png";